
import bildSechsMonate from '@/assets/icons/zeit_6_monate.svg';
import bildMehrAlsSechsMonate from '@/assets/icons/zeit_6+_monate.svg';


export const plannedReplacements = [
    { name: 'Innerhalb von 6 Monaten', available: true, value: 'six_months', api: '20552', image: bildSechsMonate },
    { name: 'In 6 Monaten oder später', available: true, value: 'next_year', api: '20553', image: bildMehrAlsSechsMonate },
];

export const plannedReplacementApi = {parameter: '17684', type: 'value_choice'}

